import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {LocalStorageService} from 'ngx-webstorage';
import {isPlatformBrowser} from '@angular/common';
import {of} from 'rxjs';

@Injectable()
export class StorageService {
  isBrowser: boolean;

  constructor(private localSt: LocalStorageService,
              @Inject(PLATFORM_ID) private platformId: any) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  saveValue(key: string, value: any) {
    if (this.isBrowser) {
      return this.localSt.store(key, value);
    }
    return null;
  }

  clear(key: string) {
    if (this.isBrowser) {
      return this.localSt.clear(key);
    }
    return null;
  }

  clearAll() {
    if (this.isBrowser) {
      return this.localSt.clear();
    }
    return null;
  }

  retrieveValue(key: string) {
    if (this.isBrowser) {
      return this.localSt.retrieve(key);
    }
    return null;
  }

  observeValue(key: string) {
    if (this.isBrowser) {
      return this.localSt.observe(key);
    }
    return of(null);
  }
}
